import { FC } from 'react';

import { Tag } from 'src/models/candidatesList';

import Banned from 'src/components/ResumeCard/Header/Tags/Banned';
import CandidateTags from 'src/components/ResumeCard/Header/Tags/CandidateTags';
import FolderTags, { FolderTagsProps } from 'src/components/ResumeCard/Header/Tags/FolderTags';
import JobSearchStatus, { JobSearchStatusProps } from 'src/components/ResumeCard/Header/Tags/JobSearchStatus';
import RelatedProfessionTag from 'src/components/ResumeCard/Header/Tags/RelatedProfessionTag';
import ResumeGifted, { ResumeGiftedType } from 'src/components/ResumeCard/Header/Tags/ResumeGifted';
import SimpleTag, { SimpleTagType } from 'src/components/ResumeCard/Header/Tags/SimpleTag';
import SkillsMatched, { SkillsMatchedProps } from 'src/components/ResumeCard/Header/Tags/SkillsMatched';
import SkillsVerified, { SkillsVerifiedProps } from 'src/components/ResumeCard/Header/Tags/SkillsVerified';
import TestResult, { TestResultProps } from 'src/components/ResumeCard/Header/Tags/TestResult';

import styles from './index.less';

export interface ResumeCardTagsData {
    isBanned?: boolean;
    isResumeCrossPlatform?: boolean;
    isWannaWork?: boolean;
    candidateTags?: Tag[];
    jobSearchStatus?: JobSearchStatusProps;
    resumeGifted?: ResumeGiftedType;
    skillsMatched?: SkillsMatchedProps;
    skillsVerified?: SkillsVerifiedProps;
    testResult?: TestResultProps;
    folderTags?: FolderTagsProps;
    relatedProfession?: boolean;
    resumeHash?: string;
    vacancyId?: number;
}

const Tags: FC<ResumeCardTagsData> = ({
    isBanned,
    isResumeCrossPlatform,
    isWannaWork,
    candidateTags,
    jobSearchStatus,
    resumeGifted,
    skillsMatched,
    skillsVerified,
    testResult,
    folderTags,
    relatedProfession,
    resumeHash,
    vacancyId,
}) => {
    return (
        <div className={styles.tags} data-qa="resume-card-tags">
            {candidateTags && (
                <CandidateTags candidateTags={candidateTags} resumeHash={resumeHash} vacancyId={vacancyId} />
            )}
            {isResumeCrossPlatform && <SimpleTag type={SimpleTagType.CrossPlatform} />}
            {resumeGifted && <ResumeGifted {...resumeGifted} />}
            {isWannaWork && <SimpleTag type={SimpleTagType.WannaWork} />}
            {jobSearchStatus && <JobSearchStatus {...jobSearchStatus} />}
            {skillsMatched && <SkillsMatched {...skillsMatched} />}
            {relatedProfession && <RelatedProfessionTag />}
            {skillsVerified && <SkillsVerified {...skillsVerified} />}
            {testResult && <TestResult {...testResult} />}
            {isBanned && <Banned />}
            {/* folder tags must be last */}
            {folderTags && <FolderTags {...folderTags} />}
        </div>
    );
};

export default Tags;
